import request from '../../utils/request';

export function doCreateIssue(params) {
  return request(`/issues`, {
    method: 'POST',
    data: params,
  });
}

export function doCreateComment(params) {
  const { issueId } = params;
  return request(`/issues/comment/${issueId}`, {
    method: 'POST',
    data: params,
  });
}
export function doCreateMissingComment(params) {
  return request(`/issues/missing/comment`, {
    method: 'POST',
    data: params,
  });
}

export function doRemoveComment(params) {
  const { commentId } = params;
  return request(`/issues/comment/${commentId}`, {
    method: 'DELETE',
  });
}

export function doMarkAsSeen(params) {
  const { issueId } = params;
  return request(`/issues/${issueId}/markseen`, {
    method: 'POST',
  });
}

export function doMarkAllAsSeen(params) {
  return request(`/issues/markallseen`, {
    method: 'POST',
    data: params,
  });
}

export function doUpdateIssue(params) {
  const { id } = params;
  return request(`/issues/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function doGetIssue(params) {
  const { id } = params;
  return request(`/issues/${id}`, {
    method: 'GET',
  });
}

export function doGetIssuesForOrder(params) {
  const { orderId, status } = params;
  return request(`/issues/order/${orderId}`, {
    method: 'GET',
    params: {
      status,
    },
  });
}

export function doGetIssues(params) {
  return request(`/issues`, {
    method: 'GET',
    params,
  });
}

export function doGetUnseenIssueCount() {
  return request(`/issues/unseen`, {
    method: 'GET',
  });
}
